import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'cmps-coaching-commitment-badge-container',
    template: ` <ng-content></ng-content>`,
    host: {
        class: 'cmps-coaching-commitment-badge-container',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmpsCommitmentBadgeContainerComponent {}
